<template>
    <main>
        <h2 class="subtitle is-5">Check</h2>
        <section class="box mb-1">
            <section class="field" v-for="(plan, index) in plansC">
                <div class="field is-horizontal">
                    <div class="field-label">
                        <label class="label">{{ index + 1}}</label>
                    </div>
                    <div class="field-body">{{ plan.title }}</div>
                    <input type="hidden"
                           :name="'pdca[' + plan.type + '][' + index + '][id]'"
                           :value="plan.id"
                    />
                    <input type="hidden"
                           :name="'pdca[' + plan.type + '][' + index + '][is_grantt]'"
                           :value="plan.is_grantt ? '1': '0'"
                    />
                </div>
                <div class="field is-horizontal mb-2" v-if="plan.is_grantt">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <div class="control">
                            <label class="label mr-1">ระยะเวลาดำเนินการ</label>
                        </div>
                        <p class="control">
                            <vue-datepicker :name="'pdca[' + plan.type + '][' + index + '][start_date]'"
                                            v-model="plan.start_date"
                                            @input="$forceUpdate()"
                            />
                        </p>
                        <div class="control">
                            <p class="label">&nbsp;ถึง&nbsp;</p>
                        </div>
                        <p class="control">
                            <vue-datepicker :name="'pdca[' + plan.type + '][' + index + '][end_date]'"
                                            :min-date="plan.start_date"
                                            v-model="plan.end_date"
                            />
                        </p>
                    </div>
                </div>
                <div class="field is-horizontal mb-2" v-if="plan.is_grantt === false">
                    <div class="field-label"></div>
                    <div class="field-body">
                        ภายใน 30 วันหลังจากดำเนินโครงการเสร็จ
                    </div>
                </div>
            </section>
        </section>
    </main>
</template>
<script type="text/babel">
    export default {
        props: {
            project: {type: Object, required: true},
            type: {type: String, required: true},
            planTitles: {type: Array, required: true},
        },

        computed: {
            plansC() {
                return this.project.pdca.filter((plan) => plan.type === this.type);
            }
        },
        methods: {}
    }
</script>